angular.module("vgresiduos").controller("EquipmentAllocationDetailCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `alocacao-equipamentos/${$stateParams.id}`);
		};
	}
]);
